<template lang="pug">
md-layout
  .md-headline Distribution Poster
  md-layout(md-flex="100")
    p.massageInfo This will be the image of the distribution, must be 16x9
    md-layout(md-flex="90")
      md-input-container(:class='{ "md-input-invalid" : formSubmitted && !file && status === "public" && (!url || url === "false") }')
        label  {{label}}
        md-file(v-model='fileName', accept='image/*', @selected='onFileSelected')
        span.md-error(v-if='formSubmitted && !validFormat') You must select a valid image (the valid ones are: JPG, JPEG, BMP, PNG)
        span.md-error(v-if='formSubmitted && !file') This field is required
      span.md-error(:style="{ color: '#ff5722'}", v-if="imgErrorShowText") {{imgErrorText}}
    md-layout(md-flex="10")
      .uploader
        md-button.md-fab(@click='upload', :class="{ 'md-primary': done }", :disabled='!file || !uploadBtnEnabled || imgErrorShowText')
          md-icon(v-if='!done', md-iconset="fa fa-cloud-upload-alt")
          md-icon(v-if='done', md-iconset="fa fa-check")
        md-theme(md-name='blue', v-if='progress > 0 && !done')
          md-spinner(:md-size='74', :md-stroke='2.2', :md-progress='progress')
  div.imageContainer
    img(v-if="!!url && url !== 'false' && progress !== 100", :src="baseUrl+url" alt="distribution image")
    md-layout.select-loader(md-flex='10', md-align='end', v-show='progress >= 99 && !done')
      md-spinner.md-accent(md-indeterminate, :md-size='25')
</template>
<script>
import uploadService from '../../services/uploadService';
import { validImageFormat } from '../../common/utils/formatValidation'

export default {
  props: {
    label: {
      type: String,
      default: 'File'
    },
    imageFileName: {
      type: String
    },
    accountID: {
      type: String
    },
    formSubmitted: {
      type: Boolean,
      required: true
    },
    validations: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fileName: this.imageFileName,
      file: null,
      progress: 0,
      done: false,
      uploading: false,
      validFormat: true,
      uploadBtn: true,
      baseUrl: `https://s3.us-east-1.amazonaws.com/${process.env.IMAGES_BUCKET_NAME}/`,
      imgErrorText:'',
      imgErrorShowText: false,
      isValidSize: false
    };
  },
  computed: {
    uploadDisabled() {
      return this.uploading || this.done;
    },
    uploadBtnEnabled() {
      return this.uploadBtn;
    }
  },
  methods: {
    async onFileSelected(files) {
      const isValidSize = await this.verifyWidhtAndHeight(files[0]);
      this.isValidSize = isValidSize;
      this.validFormat = validImageFormat(files[0].name);
      if (!this.validFormat) {
        this.progress = 0;
        this.done = false;
        this.uploading = false;
        this.validFormat = true;
        return
      }
      this.file = files[0];
    },
    async upload() {
      if (!this.uploadDisabled && this.validFormat && !!this.file) {
        this.uploading = true;
        const measureValidation = await this.verifyWidhtAndHeight(this.file);
        if (measureValidation) {
          uploadService.uploadDistributionPoster(this.file, this, this.accountID)
            .then((path) => {
              this.done = true;
              const mimeType = this.file.type;
              this.$emit('uploadSuccess', { url: `${path}`, mimeType });
              setTimeout(() => {
                this.progress = 0;
                this.done = false;
                this.uploading = false;
                this.validFormat = true;
              }, 3000);
            })
            .catch(() => {
              this.$emit('uploadFailed');
              setTimeout(() => {
                this.resetUploader();
              }, 3000);
            })
            .then(() => {
              this.uploading = false;
            });
        } else {
          this.$emit('uploadFailed');
          setTimeout(() => {
            this.resetUploader();
          }, 3000);
        }
      }
    },
    async verifyWidhtAndHeight(file) {
      return new Promise((resolve, reject) => {
        //Verify images for roku
        let result = false;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          var image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            let height = image.height;
            let width = image.width;
            let aspectRatio = width / height;
            let minWiwth = 800;
            let minHeight = 450;
            let targetAspectRatio = 16 / 9;
            let tolerance = 0.05;
            result = (width >= minWiwth && height >= minHeight) && (aspectRatio >= targetAspectRatio - tolerance && aspectRatio <= targetAspectRatio + tolerance);
            if (result) {
              this.imgErrorShowText = false;
            } else {
              this.imgErrorText = `The image must have a minimum size of ${minWiwth}x${minHeight} and an aspect ratio of 16:9`;
              this.imgErrorShowText = true;
            }
            resolve(result);
          }
        }
        reader.onerror = (e) => {
          reject('Error with file upload');
        }
      })
    },
    resetUploader() {
      this.fileName = this.imageFileName;
      this.file = null;
      this.progress = 0;
      this.done = false;
      this.uploading = false;
    }
  },
  watch: {
    imageFileName(newVal) {
      this.fileName = newVal;
    },
  }
};
</script>
        
<style lang="scss" scoped>
.uploader {
  margin: 0 auto;
  width: 56px;
  height: 56px;
  position: relative;

  .md-fab {
    margin: 0;
  }

  .md-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .md-icon {
    margin: 0 !important;
    top: 50%;
    left: 47% !important;
    transform: translate(-50%, -50%);
  }
}

.imageContainer {
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 300px;
  }
}

.massageInfo {
  font-style: italic;
  color: gray;
  font-weight: 500;
}
</style>
        


// WEBPACK FOOTER //
// src/shared-components/upload/DistributionPoster.vue